import config from '../../config';

const hitchApi = config.api.baseUrl;

export default hitchApi;
